import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { RouteService } from '../services/route.service';
import { map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouteGuard implements CanActivate {

  readonly routeService = inject(RouteService)
  readonly router = inject(Router)

  private allowedRoutes: string[] = [];

  constructor() {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const currentPath = this.normalizePath(route.url.map(u => u.path).join('/'));

    if (this.allowedRoutes.length > 0) {
      const allowed = this.allowedRoutes.some(path => this.normalizePath(path) === currentPath);
      if (!allowed) {
        this.router.navigate(['/']);
      }
      return of(allowed);
    }

    return this.routeService.getFrontendRoutes().pipe(
      map((routes: string[]) => {
        this.allowedRoutes = routes;
        const allowed = routes.some(path => this.normalizePath(path) === currentPath);
        if (allowed) {
          return true;
        } else {
          this.router.navigate(['/']);
          return false;
        }
      })
    );
  }

  private normalizePath(path: string): string {
    if (!path || path === '/') {
      return '/';
    }

    const normalized = path.startsWith('/') ? path : `/${path}`;
    return normalized.replace(/\/+$/, '') || '/';
  }
}
